import React from "react";
import { Loader2 } from "lucide-react";

export const COLORS = {
  bg: "#0A0A0A",
  surface: "#141414",
  primary: "#F2ECE4",
  secondary: "#A6A29C",
  muted: "#737373",
  chili: "#E54D2E",
  gold: "#C1A063",
  basil: "#88A066",
};

export const fmtCHF = (n) => (Number(n) || 0).toFixed(2);
export const fmtDay = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? iso : d.toLocaleDateString("fr-CH", { day: "2-digit", month: "short", year: "numeric" });
};

export const openPdf = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const Panel = ({ children, testid, className = "" }) => (
  <div className={`p-5 md:p-6 ${className}`} style={{ background: COLORS.surface, border: "1px solid rgba(242,236,228,0.06)" }} data-testid={testid}>
    {children}
  </div>
);

export const Loading = ({ label = "Chargement…" }) => (
  <div className="flex items-center gap-2 text-sm py-8" style={{ color: COLORS.secondary }}>
    <Loader2 className="w-4 h-4 animate-spin" /> {label}
  </div>
);

export const Empty = ({ children, testid }) => (
  <Panel testid={testid}><p className="text-sm text-center py-4" style={{ color: COLORS.secondary }}>{children}</p></Panel>
);

export const Tag = ({ children, color = COLORS.gold }) => (
  <span className="text-[9px] uppercase tracking-[0.2em] px-1.5 py-0.5" style={{ color, border: `1px solid ${color}`, background: "rgba(255,255,255,0.02)" }}>
    {children}
  </span>
);

export const GhostButton = ({ children, onClick, loading, icon: Icon, testid, disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={loading || disabled}
    className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] px-3 py-2 transition-colors hover:bg-white/5 disabled:opacity-50"
    style={{ color: COLORS.gold, border: `1px solid ${COLORS.gold}` }}
    data-testid={testid}
  >
    {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : Icon ? <Icon className="w-3.5 h-3.5" /> : null}
    {children}
  </button>
);

export const SoftInput = (props) => (
  <input
    {...props}
    className={`w-full px-3 py-2.5 text-sm outline-none focus:ring-1 ${props.className || ""}`}
    style={{ background: COLORS.bg, color: COLORS.primary, border: "1px solid rgba(242,236,228,0.15)", colorScheme: "dark" }}
  />
);
